/**
 * Adzuki.Charts
 */

(function GoogleCharts($, Adzuki)
{
	"use strict";

	// init a GoogleChart on your element of choice
	var chart = function GoogleChart(el, options)
	{
		var self     = this;
		var defaults = {
			title     : 'Untitled Chart',
			width     : 400,
			height    : 300,
			is3D      : false,
			responsive: true,
			tooltip   : {
				trigger: 'selection',
			}
			// animation: {
			// 	duration: 1000,
			// 	easing  : 'out',
			// 	startup : true,
			// }
		};
		var _check_lib_interval;

		this.opts = $.extend({}, defaults, options);

		try
		{
			// enforce 'new' operator to ensure 'this' points to this
			// instance, instead of the global window object
			if ((this instanceof GoogleChart) === false) {
				throw new Error("Error instantiating chart: missing 'new' operator.");
			}

			if (typeof el === 'string') {
				this.chartElement = $(el)[0];
			}
			else if (typeof el === 'object' && (el instanceof jQuery)) {
				this.chartElement = el[0];
			}

			if (this.chartElement === undefined) {
				throw new Error("'el' is not a valid selector or jQuery object.");
			}

			// google.visualization.DataTable container
			this.data = null;

			// for identifying via css
			$(this.chartElement).addClass('adzuki-chart');

			// allowed chart types in standard library
			this.chartTypes = {
				bar        : 'BarChart',
				pie        : 'PieChart',
				area       : 'AreaChart',
				line       : 'LineChart',
				combo      : 'ComboChart',
				bubble     : 'BubbleChart',      // >=3 cols required
				column     : 'ColumnChart',
				scatter    : 'ScatterChart',
				candlestick: 'CandlestickChart', // >=3 cols required
				steppedarea: 'SteppedAreaChart',
				// donut = pie, with this.opts.pieHole set between 0-1
				// histogram
			};

			// callback when selecting chart data
			this.onSelect = function onSelectCBNoop() { /**/ };

			// timer reference when resizing
			this.resizeTimer = 0;

			// check if charts lib is loaded. this won't be hit unless
			// a page already has a chart, and you are instantiating another one
			// after pageload (e.g. a chart in an modal retrieved via ajax).
			if (typeof google !== 'undefined' && typeof google.charts === 'object') {
				init();
			}
			else if (Adzuki._wait_for_chart_load === undefined)
			{
				$.ajax({
					cache   : true,
					url     : 'https://www.gstatic.com/charts/loader.js',
					dataType: 'script',
					success : function libLoaded() {
						init();
					}
				});

				// in the case where 2 charts are being instantiated on the same
				// page at the same time, we need a way to tell the second
				// chart to wait until the first has loaded the google libs.
				// when this is set to true, the second chart will fall into
				// the below 'else' block and wait until the lib is loaded.
				Adzuki._wait_for_chart_load = true;
			}
			else {
				_check_lib_interval = setInterval(function checkLibLoaded() {
					if (google.charts.loaded) {
						clearInterval(_check_lib_interval);
						init();
					}
				}, 250);
			}
		}
		catch (err)
		{
			console.error('[Adzuki.Charts]', err);
		}


		function init() {
			// this only needs to happen once per pageload
			if (google.charts.loaded !== true) {
				google.charts.load('current', {packages: ['corechart']});
				google.charts.loaded = true;
			}

			google.charts.setOnLoadCallback(function onloadcb() {
				self.data = new google.visualization.DataTable();
				$(self).triggerHandler('ready');
			});
		}
	};


	/**
	 * convert an array to a DataTable
	 * isFirstRowData (bool): first row contains data, not labels
	 */
	chart.prototype.setData = function setData(data, isFirstRowData)
	{
		// default set false, so first row contains labels
		var _isFirstRowData = isFirstRowData || false;

		try
		{
			// eslint-disable-next-line no-magic-numbers
			if (typeof data !== 'object' || data.length === 0) {
				throw new Error('Invalid data.');
			}

			this.data = google.visualization.arrayToDataTable(data, _isFirstRowData);
		}
		catch (err)
		{
			console.error('[Adzuki.Charts]', err);
		}
	};


	/**
	 * applies a formatter to the specified column of data
	 */
	chart.prototype.format = function format(type, column, opts)
	{
		var _type     = type.charAt(0).toUpperCase() + type.slice(1),
		    formatter = new google.visualization[_type+'Format'](opts);

		formatter.format(this.data, column);
	};


	/**
	 * draw chart
	 */
	chart.prototype.draw = function draw(type)
	{
		var chartType,
		    _chart;

		try
		{
			chartType = this.chartTypes[type];

			if (chartType === undefined) {
				throw new Error('Invalid chart type.');
			}

			_chart = new google.visualization[chartType](this.chartElement);
			_chart.draw(this.data, this.opts);

			// event listeners need to be re-bound every draw
			this._setupSelectEvent(_chart, chartType);
			this._setupResizeEvent(_chart);
			this._setupHoverEvent(_chart);
		}
		catch (err)
		{
			console.error('[Adzuki.Charts]', err);
		}
	};



	/**
	 * cell selection (click) event
	 */
	chart.prototype._setupSelectEvent = function _setupSelectEvent(chart, type)
	{
		var self = this,
		    cell = {},
		    selection;

		google.visualization.events.addListener(chart, 'select', function select()
		{
			selection = chart.getSelection()[0];

			if (selection === undefined) {
				return;
			}

			if (!selection.row) {
				selection.row = 0;
			}

			/**
			 * row    = name of row
			 * column = selected axis
			 * value  = value
			 */
			switch (type)
			{
				/* eslint-disable no-magic-numbers */
				case "PieChart":
					cell.row    = self.data.getValue(selection.row, 0);
					cell.column = self.data.getColumnLabel(1);
					cell.value  = self.data.getValue(selection.row, 1);
				break;

				case "ColumnChart":
				default:
					cell.row    = self.data.getValue(selection.row, 0);
					cell.column = self.data.getColumnLabel(selection.column);
					cell.value  = self.data.getValue(selection.row, selection.column);
				break;
				/* eslint-enable no-magic-numbers */
			}

			self.onSelect(cell);
		});
	};


	/**
	 * for responsive charts
	 */
	chart.prototype._setupResizeEvent = function _setupResizeEvent(chart)
	{
		var self  = this,
		    delay = 250;

		if (this.opts.width !== '100%' || !this.opts.responsive) {
			return;
		}

		$(window).on('resize', Adzuki.Debounce(function onResize() {
			clearTimeout(self.resizeTimer);
			self.resizeTimer = setTimeout(function redraw() {
				chart.draw(self.data, self.opts);
			}, delay);
		}, 500));
	};


	/**
	 * hovering over the legend shows the info window
	 */
	chart.prototype._setupHoverEvent = function _setupHoverEvent(chart)
	{
		google.visualization.events.addListener(chart, 'onmouseover', function _mouseover(entry) {
			chart.setSelection([{row: entry.row}]);
		});

		google.visualization.events.addListener(chart, 'onmouseout', function _mouseout() {
			chart.setSelection([]);
		});
	};

	chart.initiateEmailActivityChart = function initiateEmailActivityChart()
	{
		var chart_email_activity;

		chart_email_activity = new chart('.email-activity', {
			width: '100%'
		});

		$(chart_email_activity).on('ready', function setChartData() {
			Adzuki.Ajax.get('/main/emailActivityChart')
				.then(function loadEmailActivityChart(response) {
					chart_email_activity.opts['title'] = "Email Marketing Activity";
					chart_email_activity.opts['vAxis'] = {title: 'Emails Sent'};
					chart_email_activity.opts['hAxis'] = {title: 'Months'};
					chart_email_activity.setData(response);
					chart_email_activity.draw('line');
				})
				.catch(function error(err) {
					console.log(err);
				});
		});
	};

	chart.reload = function reload() {
		google.charts.load('current', {packages: ['corechart']});
		google.charts.loaded = true;
	};

	Adzuki.Chart = chart;
}(jQuery, window.Adzuki || {}));